// For TypeScript compatibility we import and export it this way
export { Number } from './exports/StatExport'
export { Currency } from './exports/StatExport'
export { Percent } from './exports/StatExport'
export { Rating } from './exports/StatExport'
export { Trend } from './exports/StatExport'
export { Label } from './exports/StatExport'
export { Info } from './exports/StatExport'
export { Inline } from './exports/StatExport'
export { Root } from './exports/StatExport'
export { Content } from './exports/StatExport'
export { Text } from './exports/StatExport'
import * as _default from './exports/StatExport'
export { _default as default }
